import * as constants from '../constants/constants';

const defaultStore = {
  searchedDishes: [],
  renderingResult: false,
  totalDishesPages: 0,
  currentDishesPage: 1,
  measures: [],
  products: [],
};

export default (state = defaultStore, action) => {
  switch (action.type) {
    case 'SEARCH_DISH_SUCCESS':
      return {
        ...state,
        searchedDishes: action.data.items.dishes.data,
        renderingResult: action.rendering,
        totalDishesPages: action.data.items.dishes.last_page,
        currentDishesPage: action.data.items.dishes.current_page,
        measures: action.data.items.measures,
      };
    case constants.SET_PRODUCTS:
      return {
        ...state,
        products: action.payload.products,
      };
    case constants.SET_MEASURES:
      return {
        ...state,
        measures: action.payload.measures,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/dishSearch.js